import { render } from "./ActionSendSms.vue?vue&type=template&id=751755f2"
import script from "./ActionSendSms.vue?vue&type=script&lang=ts"
export * from "./ActionSendSms.vue?vue&type=script&lang=ts"
script.render = render

export default script